// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoiceOrders_voice-orders__N24Og {
  display: flex;
  flex-direction: column;
  gap: 6.5rem;
}

.VoiceOrders_voice-orders__loading__aYqN2 {
  width: 10rem;
  height: 10rem;
  margin-inline: auto;
}

.VoiceOrders_voice-orders__empty__qHMNh .icon-wrapper {
  padding: 2rem;
}

.VoiceOrders_voice-orders__empty__qHMNh .icon {
  width: 6rem;
  height: 6rem;
}

.VoiceOrders_voice-orders-group__c0X5- {
  border: 1px solid var(--black-ten-opacity);
  border-radius: 1rem;
  padding: 3rem 8rem;
}

.VoiceOrders_voice-orders-group__date-wrapper__0zYct {
  margin-bottom: 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/PreviousOrders/VoiceOrders/VoiceOrders.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".voice-orders {\n  display: flex;\n  flex-direction: column;\n  gap: 6.5rem;\n}\n\n.voice-orders__loading {\n  width: 10rem;\n  height: 10rem;\n  margin-inline: auto;\n}\n\n.voice-orders__empty :global(.icon-wrapper) {\n  padding: 2rem;\n}\n\n.voice-orders__empty :global(.icon) {\n  width: 6rem;\n  height: 6rem;\n}\n\n.voice-orders-group {\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  padding: 3rem 8rem;\n}\n\n.voice-orders-group__date-wrapper {\n  margin-bottom: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voice-orders": `VoiceOrders_voice-orders__N24Og`,
	"voice-orders__loading": `VoiceOrders_voice-orders__loading__aYqN2`,
	"voice-orders__empty": `VoiceOrders_voice-orders__empty__qHMNh`,
	"voice-orders-group": `VoiceOrders_voice-orders-group__c0X5-`,
	"voice-orders-group__date-wrapper": `VoiceOrders_voice-orders-group__date-wrapper__0zYct`
};
export default ___CSS_LOADER_EXPORT___;
